import { GameStats, Solve } from "./localStorage"
import Games1Img from "../imgs/achievements/games/1.png"
import Games10Img from "../imgs/achievements/games/10.png"
import Games100Img from "../imgs/achievements/games/100.png"
import Games500Img from "../imgs/achievements/games/500.png"
import Games1000Img from "../imgs/achievements/games/1000.png"
import Streak10Img from "../imgs/achievements/streak/10.png"
import Streak100Img from "../imgs/achievements/streak/100.png"
import Streak500Img from "../imgs/achievements/streak/500.png"
import Streak1000Img from "../imgs/achievements/streak/1000.png"
import TwoSolve1Img from "../imgs/achievements/solves_in_2/1.png"
import TwoSolve10Img from "../imgs/achievements/solves_in_2/10.png"
import TwoSolve100Img from "../imgs/achievements/solves_in_2/100.png"
import TwoSolve500Img from "../imgs/achievements/solves_in_2/500.png"
import OneSolve1Img from "../imgs/achievements/solves_in_1/1.png"
import OneSolve10Img from "../imgs/achievements/solves_in_1/10.png"
import OneSolve100Img from "../imgs/achievements/solves_in_1/100.png"
import OneSolve500Img from "../imgs/achievements/solves_in_1/500.png"
import DailySolve10Img from "../imgs/achievements/daily/10.png"
import DailySolve100Img from "../imgs/achievements/daily/100.png"
import DailySolve500Img from "../imgs/achievements/daily/500.png"
import DailySolve1000Img from "../imgs/achievements/daily/1000.png"
import MiniSolve10Img from "../imgs/achievements/mini/10.png"
import MiniSolve100Img from "../imgs/achievements/mini/100.png"
import MiniSolve500Img from "../imgs/achievements/mini/500.png"
import UnlimitedSolve10Img from "../imgs/achievements/unlimited/10.png"
import UnlimitedSolve100Img from "../imgs/achievements/unlimited/100.png"
import UnlimitedSolve500Img from "../imgs/achievements/unlimited/500.png"
import UnlimitedSolve1000Img from "../imgs/achievements/unlimited/1000.png"
import CustomSolve10Img from "../imgs/achievements/custom/10.png"
import CustomSolve100Img from "../imgs/achievements/custom/100.png"
import CustomSolve500Img from "../imgs/achievements/custom/500.png"
import HardSolve1Img from "../imgs/achievements/hard/1.png"
import HardSolve10Img from "../imgs/achievements/hard/10.png"
import HardSolve100Img from "../imgs/achievements/hard/100.png"
import HardSolve500Img from "../imgs/achievements/hard/500.png"
import ExpertSolve1Img from "../imgs/achievements/expert/1.png"
import ExpertSolve10Img from "../imgs/achievements/expert/10.png"
import ExpertSolve100Img from "../imgs/achievements/expert/100.png"
import ExpertSolve500Img from "../imgs/achievements/expert/500.png"
import HexpertSolve1Img from "../imgs/achievements/hexpert/1.png"
import HexpertSolve10Img from "../imgs/achievements/hexpert/10.png"
import HexpertSolve100Img from "../imgs/achievements/hexpert/100.png"
import HexpertSolve500Img from "../imgs/achievements/hexpert/500.png"
import AllLevelsImg from "../imgs/achievements/special/all_levels.png"
import DesignerImg from "../imgs/achievements/special/designer.png"
import HelpImg from "../imgs/achievements/special/help.png"
import KnowledgeImg from "../imgs/achievements/special/knowledge.png"
import LinguistImg from "../imgs/achievements/special/linguist.png"
import SamplerPackImg from "../imgs/achievements/special/sampler.png"
import SharingImg from "../imgs/achievements/special/sharing.png"
import {
  GAME_MODE_DAILY,
  GAME_MODE_UNLIMITED,
  GAME_MODE_MINI_DAILY,
  GAME_MODE_CUSTOM
} from "../constants/strings"
import {
  MAX_CHALLENGES,
} from "../constants/settings"

const DEFAULT_HEIGHT = "h-32"

export type Tier = "tier-1" | "tier-2" | "tier-3" | "mystery"

export type AchievementKey = "help" | "share" | "designer" | "knowledge" | "linguist"


// TODO filter solves so you don't get credit for the same puzzle

export interface Achievement {
  getTier(): Tier
  getStyle(): string
  getImg(): string
  getTitle(): string
  getDescription(): string
  has(stats: GameStats): boolean
  child?: Achievement
}

export abstract class AbstractAchievement {
  public child?: AbstractAchievement
  constructor(
    private img: string,
    private title: string,
    private description: string,
    protected style?: string,
    protected tier?: Tier) {
  }

  getImg(): string {
    return this.img
  }

  getTitle(): string {
    return this.title
  }

  getDescription(): string {
    return this.description 
  }

  getStyle(): string {
    return this.style ?? DEFAULT_HEIGHT
  }

  getTier(): Tier {
    return this.tier ?? "mystery"
  }

  abstract has(stats: GameStats): boolean
}


export abstract class NumAchievement extends AbstractAchievement {
  constructor(
    img: string,
    title: string,
    description: string,
    public n: number,
    style?: string,
    tier?: Tier) {
    super(img, title, description, style, tier)
  }

  getStyle(): string {
    if(this.style) {
      return this.style
    }
    if(this.n <= 10) {
      return DEFAULT_HEIGHT
    }
    if(this.n <= 100) {
      return "h-52"
    }
    return "h-80"
  }

  getTier(): Tier {
    if(this.tier) {
      return this.tier
    }
    if(this.n <= 10) {
      return "tier-1"
    }
    if(this.n <= 100) {
      return "tier-2"
    }
    if(this.n >= 500) {
      return "tier-3"
    }
    return "mystery"
  }
}

const solved = (solve: Solve) => {
  return solve.guesses <= MAX_CHALLENGES
}

const filterDupes = (acc: Map<string, Solve>, s: Solve) => {
  const key = `${s.solution},${s.mode}`
  if(!acc.has(key)) {
    acc.set(key, s)
  }
  return acc
}

const dedupedStats = (stats: GameStats) => {
  return [...(stats.solves ?? [])
    .reduce(filterDupes, new Map()).values()]
}

class GamesAchievement extends NumAchievement {
  has(stats: GameStats) {
    return stats.totalGames >= this.n
  }
}


class StreakAchievement extends NumAchievement {
  has(stats: GameStats) {
    return stats.bestStreak >= this.n
  }
}

class TwoSolveAchievement extends NumAchievement {
  has(stats: GameStats) {
    return stats.winDistribution[1] >= this.n
  }
}

class OneSolveAchievement extends NumAchievement {
  has(stats: GameStats) {
    return stats.winDistribution[0] >= this.n
  }
}

class DailySolveAchievement extends NumAchievement {
  has(stats: GameStats) {
    return dedupedStats(stats).filter((s) => s.mode === GAME_MODE_DAILY && solved(s)).length >= this.n
  }
}

class MiniSolveAchievement extends NumAchievement {
  has(stats: GameStats) {
    return dedupedStats(stats).filter((s) => s.mode === GAME_MODE_MINI_DAILY && solved(s)).length >= this.n
  }
}

class UnlimitedSolveAchievement extends NumAchievement {
  has(stats: GameStats) {
    return dedupedStats(stats).filter((s) => s.mode === GAME_MODE_UNLIMITED && solved(s)).length >= this.n
  }
}

class CustomSolveAchievement extends NumAchievement {
  has(stats: GameStats) {
    return dedupedStats(stats)
      .filter((s) => s.mode === GAME_MODE_CUSTOM && solved(s)).length >= this.n
  }
}

class HardSolveAchievement extends NumAchievement {
  has(stats: GameStats) {
    return dedupedStats(stats)
      .filter((s) => s.hard && solved(s)).length >= this.n
  }
}

class ExpertSolveAchievement extends NumAchievement {
  has(stats: GameStats) {
    return dedupedStats(stats)
      .filter((s) => s.expert && solved(s)).length >= this.n
  }
}

class HexpertSolveAchievement extends NumAchievement {
  has(stats: GameStats) {
    return dedupedStats(stats)
      .filter((s) => s.expert && s.hard && solved(s)).length >= this.n
  }
}

class Sampler extends AbstractAchievement {
  constructor() {
    super(SamplerPackImg, "The Sampler Pack", "Solve a daily, mini, unlimited, and custom puzzle", "h-48")
  }

  has(stats: GameStats) {
    const solves = dedupedStats(stats)
    return solves.some((s) => solved(s) && s.mode === GAME_MODE_DAILY) &&
           solves.some((s) => solved(s) && s.mode === GAME_MODE_MINI_DAILY) &&
           solves.some((s) => solved(s) && s.mode === GAME_MODE_UNLIMITED) &&
           solves.some((s) => solved(s) && s.mode === GAME_MODE_CUSTOM)
  }
}

class AllLevels extends AbstractAchievement {
  constructor() {
    super(AllLevelsImg, "All Levels, No Problem", "Solve a puzzle on every difficulty mode", "h-48")
  }

  has(stats: GameStats) {
    const solves = dedupedStats(stats)
    return solves.some((s) => solved(s) && s.expert && s.hard) &&
           solves.some((s) => solved(s) && s.expert) &&
           solves.some((s) => solved(s) && s.hard)
  }
}

class KeyedAchievement extends AbstractAchievement {
  constructor(
    public key: AchievementKey,
    img: string,
    title: string,
    description: string,
    style?: string,
    tier?: Tier,
    ) {
   super(img, title, description, style, tier)
  }

  has(stats: GameStats) {
    return (stats.achievements ?? []).includes(this.key)
  }
}

class ALittleHelp extends KeyedAchievement {
  constructor() {
    super("help", HelpImg, "A Little Help Won't Hurt", "Use a hint", "h-40")
  }
}

class PuzzleDesigner extends KeyedAchievement {
  constructor() {
    super("designer", DesignerImg, "Puzzle Designer", "Create a custom puzzle", "h-40")
  }
}

class SharingIsCaring extends KeyedAchievement {
  constructor() {
    super("share", SharingImg, "Sharing is Caring", "Share your stats")
  }
}

class KnowledgeSeeker extends KeyedAchievement {
  constructor() {
    super("knowledge", KnowledgeImg, "Knowledge Seeker", "Visit the tips and tricks page")
  }
}

class Linguist extends KeyedAchievement {
  constructor() {
    super("linguist", LinguistImg, "Linguist", "Guess an unusual word")
  }
}

export const ALL_ACHIEVEMENTS: Achievement[] = (() => {
  const achievements = [
  new GamesAchievement(Games1Img, "The First Step", "Play your first game", 1),
  new GamesAchievement(Games10Img, "A Stellar Start", "Play 10 games", 10, "h-40"),
  new GamesAchievement(Games100Img, "Centurion", "Play 100 games", 100),
  new GamesAchievement(Games500Img, "Master", "Play 500 games", 500, "h-60", "tier-2"),
  new GamesAchievement(Games1000Img, "Legend", "Play 1000 games", 1000),
  new StreakAchievement(Streak10Img, "Flawless", "Best streak of 10 games", 10),
  new StreakAchievement(Streak100Img, "Unstoppable", "Best streak of 100 games", 100),
  new StreakAchievement(Streak500Img, "Impeccable", "Best streak of 500 games", 500, "h-60", "tier-2"),
  new StreakAchievement(Streak1000Img, "Perfection", "Best streak of 1000 games", 1000, "h-96"),
  new TwoSolveAchievement(TwoSolve1Img, "Double Delight", "Solve a puzzle in 2 guesses", 1, "h-24"),
  new TwoSolveAchievement(TwoSolve10Img, "Dual Deduction", "Solve 10 puzzles in 2 guesses", 10, "h-44"),
  new TwoSolveAchievement(TwoSolve100Img, "Twin Triumph", "Solve 100 puzzles in 2 guesses", 100),
  new TwoSolveAchievement(TwoSolve500Img, "Perfectly Paired", "Solve 500 puzzles in 2 guesses", 500),
  new OneSolveAchievement(OneSolve1Img, "Bullseye", "Solve a puzzle in 1 guess", 1),
  new OneSolveAchievement(OneSolve10Img, "Prodigy", "Solve 10 puzzles in 1 guess", 10, "h-44"),
  new OneSolveAchievement(OneSolve100Img, "Mastermind", "Solve 100 puzzles in 1 guess", 100),
  new OneSolveAchievement(OneSolve500Img, "Genius", "Solve 500 puzzles in 1 guess", 500),
  new DailySolveAchievement(DailySolve10Img, "Daily Dedication", "Solve the daily puzzle 10 times", 10),
  new DailySolveAchievement(DailySolve100Img, "Daily Sleuth", "Solve the daily puzzle 100 times", 100),
  new DailySolveAchievement(DailySolve500Img, "Daily Maestro", "Solve the daily puzzle 500 times", 500, "h-60", "tier-2"),
  new DailySolveAchievement(DailySolve1000Img, "Daily Hero", "Solve the daily puzzle 1000 times", 1000),
  new MiniSolveAchievement(MiniSolve10Img, "Micro Maven", "Solve 10 mini puzzles", 10),
  new MiniSolveAchievement(MiniSolve100Img, "Tiny Tactician", "Solve 100 mini puzzles", 100),
  new MiniSolveAchievement(MiniSolve500Img, "Mini Monarch", "Solve 500 mini puzzles", 500),
  new CustomSolveAchievement(CustomSolve10Img, "Puzzle Pioneer", "Solve 10 custom puzzles", 10),
  new CustomSolveAchievement(CustomSolve100Img, "Bespoke Brainiac", "Solve 100 custom puzzles", 100),
  new CustomSolveAchievement(CustomSolve500Img, "Custom Champion", "Solve 500 custom puzzles", 500),
  new UnlimitedSolveAchievement(UnlimitedSolve10Img, "Boundless", "Solve 10 unlimited puzzles", 10),
  new UnlimitedSolveAchievement(UnlimitedSolve100Img, "Endless Solver", "Solve 100 unlimited puzzles", 100),
  new UnlimitedSolveAchievement(UnlimitedSolve500Img, "Infinite Intellect", "Solve 500 unlimited puzzles", 500, "h-60", "tier-2"),
  new UnlimitedSolveAchievement(UnlimitedSolve1000Img, "", "Solve 1000 unlimited puzzles", 1000, "h-96"),
  new HardSolveAchievement(HardSolve1Img, "One Tough Step", "Solve a puzzle on hard mode", 1),
  new HardSolveAchievement(HardSolve10Img, "Persistence Pays", "Solve 10 puzzles on hard mode", 10, "h-40"),
  new HardSolveAchievement(HardSolve100Img, "Tenacious", "Solve 100 puzzles on hard mode", 100),
  new HardSolveAchievement(HardSolve500Img, "Indomitable Spirit", "Solve 500 puzzles on hard mode", 500, "h-96"),
  new ExpertSolveAchievement(ExpertSolve1Img, "Expert Beginnings", "Solve a puzzle on expert mode", 1),
  new ExpertSolveAchievement(ExpertSolve10Img, "Advanced Ambition", "Solve 10 puzzles on expert mode", 10),
  new ExpertSolveAchievement(ExpertSolve100Img, "Pro Puzzler", "Solve 100 puzzles on expert mode", 100),
  new ExpertSolveAchievement(ExpertSolve500Img, "Grandmaster", "Solve 500 puzzles on expert mode", 500),
  new HexpertSolveAchievement(HexpertSolve1Img, "Challenge Accepted", "Solve a puzzle on hexpert mode", 1),
  new HexpertSolveAchievement(HexpertSolve10Img, "Strategist", "Solve 10 puzzles on hexpert mode", 10, "h-40"),
  new HexpertSolveAchievement(HexpertSolve100Img, "Powerhouse", "Solve 100 puzzles on hexpert mode", 100),
  new HexpertSolveAchievement(HexpertSolve500Img, "Supreme Solver", "Solve 500 puzzles on hexpert mode", 500, "h-96"),
  new Sampler(),
  new AllLevels(),
  new ALittleHelp(),
  new PuzzleDesigner(),
  new SharingIsCaring(),
  new KnowledgeSeeker(),
  new Linguist(),
]
  achievements.forEach((a) => {
    if(!(a instanceof NumAchievement)) {
      return
    }
    if(a.n === 1) {
      return
    }
    for(let i = achievements.length - 1; i >= 0; i--) {
      const c = achievements[i]
      if(c instanceof NumAchievement &&
        c.constructor.name === a.constructor.name
        && c.n < a.n) {
        a.child = c
        break
      }
    }
  })

  return achievements
})()

export const TIERED_ACHIEVEMENTS = ALL_ACHIEVEMENTS.reduce((acc: Map<Tier, Achievement[]>, a: Achievement) => {
  if(!acc.has(a.getTier())) {
    acc.set(a.getTier(), [])
  }
  acc.get(a.getTier())!.push(a)
  return acc
}, new Map<Tier, Achievement[]>()) 

export const getAchievements = (stats: GameStats) => {
  return new Set(ALL_ACHIEVEMENTS.filter((a) => a.has(stats)))
}

const KEYED_ACHIEVEMENTS = new Map(ALL_ACHIEVEMENTS.filter((c) => c instanceof KeyedAchievement).map((c) => [(c as KeyedAchievement).key, c]))

export const getKeyedAchievement = (key: AchievementKey) => {
  return KEYED_ACHIEVEMENTS.get(key)
}
